export default __webpack_public_path__ + "static/soup_dark-55011edf731486b8ad96806b6a8c611f.svg";